import SidebarTopContent from './SidebarTopContent';

export default SidebarTopContent;
